import React from 'react';
import { useGoogleSearchContext } from '../../../components/search/GoogleInstantSearch';
import HitsPerPageControl from './HitsPerPageControl';

const GoogleHitsPerPage = () => {
  const { state, setHitsPerPage } = useGoogleSearchContext();

  return (
    <HitsPerPageControl
      searchTerm={state.query}
      currentValue={state.hitsPerPage}
      onSelect={value => setHitsPerPage(value)}
    />
  );
};

export default GoogleHitsPerPage;
